export const PIE_TRANSITION_DURATION = '220ms';
export const PIE_TRANSITION_EASING = 'cubic-bezier(0.2, 0, 0, 1)';
export const PIE_ANIMATION_CONFIG = { duration: PIE_TRANSITION_DURATION, easing: PIE_TRANSITION_EASING };
